export const AnalyticsEvents = {
  CtaClick: "cta_click",
  ExternalLinkClick: "external_link_click",
  LanguageSwitch: "language_switch",
  ProductCardClick: "product_card_click",
  SupportClick: "support_click",
  PrivacyClick: "privacy_click",
  ContactClick: "contact_click",
  PageView: "page_view",
  ClickNav: "click_nav",
  ClickCall: "click_call",
  ClickWechat: "click_wechat",
  OpenWechatModal: "open_wechat_modal",
  CopyWechatId: "copy_wechat_id",
  ClickProductCard: "click_product_card"
} as const;

export type AnalyticsEventName = (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];

export type AnalyticsEventPayload = {
  product?: string;
  page?: string;
  locale?: string;
  target?: string;
  from?: string;
  to?: string;
};
